import * as axios from '../../axios-extended'
import { NewTax, Nullable, Tax, Taxes, TaxesSearchRequest } from '.'
import * as t from 'io-ts'

export const getTaxes = (
  {
    organizationName,
    itemsPerPage = 10,
    page = 0,
    ...rest
  }: {
    organizationName: string
  } & Partial<Nullable<TaxesSearchRequest>>,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`/prosperbill/api/tax/${organizationName}`, {
    cancelToken,
    params: { itemsPerPage, page, ...rest },
    decoder: Taxes,
  })

export const createTax = (
  { organization, ...tax }: { organization: string } & NewTax,
  cancelToken?: axios.CancelToken
) =>
  axios.post(`/prosperbill/api/tax/${organization}`, tax, {
    cancelToken,
    decoder: t.unknown,
  })

export const updateTax = (
  { organization, ...tax }: { organization: string } & Tax,
  cancelToken?: axios.CancelToken
) =>
  axios.put(`/prosperbill/api/tax/${organization}`, tax, {
    cancelToken,
    decoder: t.unknown,
  })

export const deleteTax = (
  organizationName: string,
  id: number,
  cancelToken?: axios.CancelToken
) =>
  axios.delete_(`/prosperbill/api/tax/${organizationName}/${id}`, {
    cancelToken,
    decoder: t.unknown,
  })

export const getTax = (
  organization: string,
  id: number,
  cancelToken?: axios.CancelToken
) =>
  axios.get(`/prosperbill/api/tax/${organization}/${id}`, {
    cancelToken,
    decoder: Tax,
  })
